import React, { useEffect, useRef } from 'react'

import { ExpandableWrapper } from './Expandable.styled'
import { updateHeight } from './utils'

type ExpandableProps = {
    isOpen: boolean
    children?: React.ReactNode
}

export const Expandable = ({ isOpen, children }: ExpandableProps): JSX.Element => {
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        updateHeight(ref, isOpen)
    }, [isOpen])

    return (
        <ExpandableWrapper aria-expanded={isOpen} ref={ref} data-testid="Expandable">
            {children}
        </ExpandableWrapper>
    )
}
